export enum DtcType {
    ReplaceValue = 1,
    ReplaceSignature = 2
}
